import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import React, { Component } from 'react';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var findOption = function findOption(options) {
  var valueProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  return function (value) {
    if (_typeof(value) === 'object') return value;
    var index = options.findIndex(function (option) {
      return option[valueProperty] === value;
    });
    return options[index];
  };
};

var getOptionFromValue = function getOptionFromValue(_ref) {
  var value = _ref.value,
      options = _ref.options,
      valueProperty = _ref.valueProperty,
      isMulti = _ref.isMulti;

  if (Array.isArray(value) && isMulti) {
    return value.map(findOption(options, valueProperty));
  }

  return findOption(options, valueProperty)(value);
};

var withSelectStringValueConverter = function withSelectStringValueConverter(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {});

      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var value = this.state.value;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          value: value
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        if (typeof nextProps.value !== 'undefined' && nextProps.value !== prevState.prevPropValue) {
          return {
            prevPropValue: nextProps.value,
            value: getOptionFromValue(nextProps)
          };
        }

        return null;
      }
    }]);

    return _class;
  }(Component), _defineProperty(_class, "defaultProps", {
    valueProperty: 'value',
    labelProperty: 'label'
  }), _temp;
};

export default withSelectStringValueConverter;
//# sourceMappingURL=withSelectStringValueConverter.js.map
